import React from "react";
import "./PoliticaPrivacidade.css";

const PoliticaPrivacidade = () => {
  return (
    <div className="App">
      <div className="privacy-content">
        <h1>Política de Privacidade</h1>
        <div className="privacy-section">
          <p>
            Bem-vindo à Custos Agro. Estamos comprometidos em proteger suas informações pessoais e garantir sua privacidade. Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos os dados que você nos fornece ao utilizar nossos aplicativos e serviços.
          </p>
          <p>
            <strong>1. Coleta de Dados</strong><br />
            Coletamos dados como seu nome, e-mail, CPF e informações de pagamento (ex.: dados de cartão via Stripe) para oferecer nossos serviços. Esses dados são armazenados de forma segura em nosso banco de dados.
          </p>
          <p>
            <strong>2. Uso dos Dados</strong><br />
            Utilizamos seus dados para gerenciar suas assinaturas (ex.: Calccafe, Calcleite), fornecer suporte técnico e melhorar nossos aplicativos. Dados de pagamento são processados exclusivamente pela Stripe, e não armazenamos informações sensíveis de cartões.
          </p>
          <p>
            <strong>3. Compartilhamento de Dados</strong><br />
            Não compartilhamos seus dados pessoais com terceiros, exceto quando necessário para cumprir obrigações legais ou processar pagamentos via Stripe. Suas informações de uso podem ser agregadas para análises internas, sem identificação pessoal.
          </p>
          <p>
            <strong>4. Segurança</strong><br />
            Implementamos medidas de segurança, como criptografia e autenticação, para proteger seus dados. No entanto, nenhum sistema é completamente imune a ataques, e recomendamos que você proteja suas credenciais de acesso.
          </p>
          <p>
            <strong>5. Direitos do Usuário</strong><br />
            Você pode acessar, corrigir ou solicitar a exclusão de seus dados a qualquer momento, entrando em contato pelo e-mail <a href="mailto:custosagro@gmail.com">custosagro@gmail.com</a>. Também oferecemos a opção de cancelar assinaturas diretamente no aplicativo.
          </p>
          <p>
            <strong>6. Alterações na Política</strong><br />
            Podemos atualizar esta política periodicamente. Notificaremos você sobre mudanças significativas por e-mail ou dentro do aplicativo. A última atualização foi em 27 de junho de 2025.
          </p>
          <a href="/" className="back-link">Voltar para a Home</a>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;